import { useEffect, useState } from "react";

import * as workspaceService from "V2.0/services/projectService";

export default function useWorkspaceSettings(workspaceId) {
  const [workspaceSettings, setWorkspaceSettings] = useState({});

  async function fetchWorkspaceSettings() {
    try {
      const response = await workspaceService.getSettings(workspaceId);
      const data = response.data;
      setWorkspaceSettings(data);
    } catch (e) {
      return;
    }
  }

  useEffect(() => {
    if (workspaceId) {
      fetchWorkspaceSettings();
    }
  }, [workspaceId]);

  return {
    workspaceSettings,
    fetchWorkspaceSettings,
  };
}
